import axios from 'axios';
import React, { Component } from 'react';
import WaveSurfer from 'wavesurfer.js';
import ReactDOM from "react-dom";
import { createProfile } from '../../actions/profileActions';

export default class AudioPlayer extends Component<any, any> {
  $el;
  wavesurfer;
  $waveform;
  currentDialogId;

  componentDidMount() {
    this.$el = ReactDOM.findDOMNode(this)
    this.$waveform = this.$el.querySelector('.wave')
    this.wavesurfer = WaveSurfer.create({
      container: this.$waveform,
      waveColor: '#337ab7',
      progressColor: '#23527c',
      height: 68,
      backend: 'MediaElement'
    })
    if (this.props.src) {
      this.wavesurfer.load(this.props.src);
    }

    this.wavesurfer.on('pause', () => {
      console.log('pause');
      this.wavesurfer.params.container.style.opacity = 0.7;
    });

    this.wavesurfer.on('ready', () => {
      // this.wavesurfer.play();
    });

    this.wavesurfer.on('finish', () => {
      console.log('finish audio');
      axios.post(`/api/profile/dialogue`, {dialogue: this.currentDialogId});
    });
     
  }

  // componentWillReceiveProps({ src }) {
  //   console.log(`Audio receive props : ${src}`);
  //   if (src) {
  //     this.wavesurfer.load(src);
  //     setTimeout(() => {
  //       this.wavesurfer.play();
  //     });
  //   }
  // }

  onPlay = (src, dialogId) => {
    this.currentDialogId = dialogId;
    // this.wavesurfer.play();
    this.wavesurfer.load(src);
    setTimeout(() => {
      this.wavesurfer.play();
    });
  }

  onStop = () => {
    if (this.wavesurfer && this.wavesurfer.isPlaying()) {
      this.wavesurfer.stop();
    }
  }

  onPause = () => {
    if (this.wavesurfer && this.wavesurfer.isPlaying()) {
      this.wavesurfer.pause();
    }
  }

  onPlayPause = () => {
    if (this.wavesurfer && !this.wavesurfer.isPlaying()) {
      this.wavesurfer.playPause();
    }
  }
  

  // destroy player on unmount
  componentWillUnmount() {
    if (this.wavesurfer) {
      this.wavesurfer.destroy();
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
      <>	
        <div className='waveform'>
          <div className='wave'></div>
        </div>
      </>
    )
  }
}